import { App } from 'vue'
import { registerFlexComponentsContainer } from '../../AppAndPageLayouts/front/components/ComponentsContainer/FlexComponentsContainer.config'
import SimpleContainer from '../../AppAndPageLayouts/front/components/ComponentsContainer/SimpleContainer.vue'
import ComposableComponentItemRenderer from '../../ComposableComponentBuilder/front/components/Renderer/ComposableComponentItemRenderer.vue'
import ComposableComponentRenderer from '../../ComposableComponentBuilder/front/components/Renderer/ComposableComponentRenderer.vue'
import ComposableComponentRendererById from '../../ComposableComponentBuilder/front/components/Renderer/ComposableComponentRendererById.vue'
import { findSharedComponentIds } from '../../ComposableComponents/ComposableComponentInstanceItem'
import { registerComposableComponentSettings } from '../../ComposableComponents/registerComposableComponentSettings'
import { openBuilderEditPage } from '../models/core_composable_component_definitions'
export const registerComposableComponentBuilderComponents = (Vue: App) => {
  Vue.component('SimpleContainer', SimpleContainer)
  Vue.component('ComposableComponentRenderer', ComposableComponentRenderer)
  Vue.component('ComposableComponentRendererById', ComposableComponentRendererById)
  registerComposableComponentSettings('ComposableComponentRendererById', {
    label: 'Composable',
    category: 'container',
    configColumns: {
      pageId: {
        beforeComponents: [
          {
            template: '<p class="small">ID, 一意キーのどちらかを指定します。</p>',
          },
        ],
        label: 'コンポーネント',
        type: 'RELATIONSHIP_MANY_TO_ONE',
        relationshipManyToOne: {
          collectionName: 'core_composable_component_definitions',
          labelFormatter: (item) =>
            `${item.name} (key: ${item.key}${item.urlPath ? `, url: ${item.urlPath}` : ''})`,
        },
        editCallback({ row, newValue, oldValue }) {
          if (newValue !== oldValue) {
            row.sharedComponentId = ''
            row.itemKey = ''
          }
          return row
        },
        afterComponents: [
          {
            template:
              '<div v-if="pageId"><a href="#" @click.prevent="openBuilderEditPage" class="small"><ficon type="external-link-alt"/> ビルダーで編集</a></div>',
            methods: {
              openBuilderEditPage() {
                openBuilderEditPage({
                  id: this.pageId,
                })
              },
            },
            computed: {
              pageId() {
                return this.$parent?.record?.pageId
              },
            },
          },
        ],
      },
      itemKey: {
        type: 'STRING',
        label: '一意キー',
        editCallback({ row, newValue, oldValue }) {
          if (newValue !== oldValue) {
            row.pageId = null
            row.sharedComponentId = ''
          }
          return row
        },
        enableIf: (row) => !row.pageId,
      },
      sharedComponentId: {
        type: 'STRING',
        label: '共有コンポーネント指定',
        inputHelpText:
          '選択したコンポーネント内の "共有コンポーネント" を指定して、そのコンポーネントのみ表示可能です。',
        // enableIf: (record) => !!(record.pageId || record.itemKey),
        // inputHelpText: '',
        dynamicSelections: true,
        selections: async (record, currentValue, initialValue, recordRoot, callerVueInstance) => {
          if (!record.pageId && !record.itemKey) {
            return []
          }
          const filter = record.pageId
            ? { id: { _eq: record.pageId } }
            : { key: { _eq: record.itemKey } }
          const data = (
            await $core.$models.core_composable_component_definitions.find({
              filter,
            })
          )?.[0]
          if (!data) {
            return []
          }
          return findSharedComponentIds(data.children)
        },
        editCallback({ row, newValue, oldValue, callerVueInstance }) {
          if(newValue !== oldValue && newValue) {
            // ラベルを変更する
            callerVueInstance?.ComposableComponentBuilderServiceInstance?.updateComponentByPropName?.(
              newValue,
             null,
              'label'
            )
          }
          return row
        }
      },
    },
  })
  Vue.component('ComposableComponentItemRenderer', ComposableComponentItemRenderer)
  Vue.component(
    'ComposableComponentsTreeStructureItem',
    $frameworkUtils.defineAsyncComponent(
      () =>
        import('./components/BuilderControls/ComposableComponentsTreeStructureItem.vue'),
    ),
  )

  Vue.component(
    'ComposableComponentBuilder',
    $frameworkUtils.defineAsyncComponent(
      () => import('./components/ComposableComponentBuilder.vue'),
    ),
  )

  Vue.component(
    'ComposableComponentBuilderModelInput',
    $frameworkUtils.defineAsyncComponent(
      () => import('./components/ComposableComponentBuilderModelInput.vue'),
    ),
  )

  Vue.component(
    'ComposableComponentsTreeStructureViewerItem',
    $frameworkUtils.defineAsyncComponent(
      () =>
        import(
          './components/BuilderControls/ComposableComponentsTreeStructureViewerItem.vue'
        ),
    ),
  )
  Vue.component(
    'ComposableComponentsTreeStructureEditor',
    $frameworkUtils.defineAsyncComponent(
      () =>
        import(
          './components/BuilderControls/ComposableComponentsTreeStructureEditor.vue'
        ),
    ),
  )
  Vue.component(
    'ComposableComponentsTreeStructureViewer',
    $frameworkUtils.defineAsyncComponent(
      () =>
        import(
          './components/BuilderControls/ComposableComponentsTreeStructureViewer.vue'
        ),
    ),
  )

  registerFlexComponentsContainer(Vue)
}
